import { useTheme } from "../../../theme/ThemeProvider";
import { ITheme } from "../../../theme/ITheme";
import { IPageStyles } from "../../styles";

export const usePageStyles = (theme?: ITheme): IPageStyles => {
    if (theme === undefined) {
        theme = useTheme();
    }

    return {
        pageContainer: {
            //width: "100%",
        },
        pageSection: {
            backgroundColor: theme.palette.background.main,
            borderRadius: theme.shape.borderRadiusLg,
        },
        pageTitle: {
            fontWeight: theme.font.weights.semiBold,
            color: theme.palette.accent.dark,
            //lineHeight: theme.font.sizes.lg
        },
        pageSubtitle: {
            fontWeight: theme.font.weights.regular,
            color: theme.palette.text.main
        },
        actionButton: {
            fontSize: "1.5em",
            //color: theme.palette.grey
        },
        newButton: {
            fontSize: 18,
            height: 51,
            verticalAlign: "middle",
            backgroundColor: theme.palette.background.main,
            border: `1px solid ${theme.palette.accent.dark}`,
            color: theme.palette.accent.dark,
        },
        newButtonIcon: {
            fontSize: 22,
        },
    }
}